import React, { useState, useEffect, forwardRef } from "react";
import FullCalendar, { constrainPoint } from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ko } from "date-fns/locale";
import {
  Box, Select, MenuItem, FormControl, InputLabel, Dialog,
  AppBar, Toolbar, IconButton,
  Typography
} from "@mui/material";
import CenterSelect from "./CenterSelect";
import { configState, loginState } from "../lib/State";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import moment from "moment";
import add_comma from "../lib/add_comma";
import remove_comma from "../lib/remove_comma";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import pr from "../lib/pr";
import styled from "@emotion/styled";

// react-bootstrap-table-next
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

const FullCalendarContainer = styled(Box)`
    width: 1000px;
    .fc {
        height: 700px;
    }
`;

const Title = styled(Box)`
  margin-top: 5px;
  font-size:24px;
`

function PosCardCalendar(props) {
  const { tcidParent, login } = props;
  const [loaded, setLoaded] = useState(true);
  const cid = get_cid();
  const token = get_token();
  const [sdate, setSdate] = useState("");
  const [edate, setEdate] = useState("");
  const [rows, setRows] = useState([]);
  const [calendar_type, setCalendarType] = useState("sale");
  const [tdate, setTdate] = useState(null);
  const [open, setOpen] = useState(false);
  const [fcid, setFcid] = useState(''); // drop
  const [start_date, setStartDate] = useState('');
  const [sum, setSum] = useState(0);
  const [tcid, setTcid] = useState('');
  const [sale, setSale] = useState([]);
  const rate = 7; // 수수료
  const [origin , setOrigin ] = useState(0); // 상품가격

  const load_data = async () => {
    let result = await axios.post(configState.api + "/chart/card_calendar", {
      token: token,
      cid: cid,
      tcid: tcid,
      sdate: sdate,
      edate: edate,
      fcid: fcid
    });

    if(result.data.success === 1) {
      setRows(result.data.rows);

      // 합계계산
      setSum(result.data.month_sale);
      setOrigin(result.data.month_origin);
      
      // 주간합계
      setSale(result.data.sale);
    }
  };

  useEffect(() => {
    if(tcid !== '' ) {
      load_data();
    }
  }, [tcid, sdate]);

  const monthChange = (playload) => {
    setSdate(moment(playload.start).format("YYYY-MM-DD"));
    setEdate(moment(playload.end).format("YYYY-MM-DD"));
  };

  const onSelect = (info) => {
    setTdate(info.startStr);
    setOpen(true);
  }

  return (
    <Box>
      <Detail fcid={fcid} tdate={tdate} open={open} tcid={tcid} setOpen={setOpen} login={login}></Detail>

      <Title>카드매출 달력</Title>

      <Box display="flex" sx={{ width: 1000 }}>        
        <Box flexGrow="1" sx={{ fontSize: 16 }}>
          <Box>상품가격:<span style={{fontSize:18}}>{add_comma(origin)}</span>원 / 
          카드매출:<span style={{fontSize:18}}>{add_comma(sum)}</span>원 / 로열티:<span>{add_comma(origin/100*rate)}</span>원</Box>
          { sale.map((item, index)=>{
            return <Box fontSize={13} key={index}> 
            <Box display="inline-block" width={20}>{index+1}</Box> 
            <Box display="inline-block" width={180}>{item.start} ~ {item.end}</Box>            
            <Box display="inline-block" width={110}>매출:{add_comma(item.total)}원 </Box>
            </Box>          
          })}          
        </Box>
        <Box>
          <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />
        </Box>
      </Box>

      <FullCalendarContainer sx={{ mt: 3 }}>
        <FullCalendar
          selectable={true}
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          events={rows}
          locale="ko"
          datesSet={monthChange}
          showNonCurrentDates={true}
          select={onSelect}
          fixedWeekCount={false}
        />
      </FullCalendarContainer>
    </Box>
  );
}
export default PosCardCalendar;


// ======================= //
// Detail : depth1
// ======================= //
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Detail = (props) => {
  const { tdate, tcid, open, setOpen, login, fcid } = props;

  const onClose = () => {
    setOpen(false);
  }

  return <Dialog
    open={open}
    TransitionComponent={Transition}
    onClose={onClose}
    maxWidth="lg"
  >
    <AppBar sx={{ position: "static" }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography style={{ fontSize: 18 }}>카드매출 내역</Typography>
        </Box>
        <IconButton
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
    <Box>
      <DetailData fcid={fcid} tcid={tcid} tdate={tdate} login={login} sdate={tdate} />
    </Box>
  </Dialog>
}

// ======================= //
// Detail Data : depth2
// ======================= //

// 필터링 아이콘 안보이는 버그 수정
// const Container = styled(Box)`

// border: 3px solid #cccccc;



// th .order-4:after {
//   content: "\2193";
//   opacity: 0.4;
// }

// th .caret-4-asc:before {
//   margin-left: 3.5px;
//   content: "\2191";
// }

// th .caret-4-asc:after {
//   content: "\2193";
//   opacity: 0.4;
// }

// th .caret-4-desc:before {
//   margin-left: 3.5px;
//   content: "\2191";
//   opacity: 0.4;
// }

// th .caret-4-desc:after {
//   content: "\2193";
// }
// `;

const DetailData = (props) => {

  const { tcid, tdate, login, sdate, fcid } = props;
  const [rows, setRows] = useState([]);

  const load_data = async () => {
    let result = await axios.post(configState.api + '/gympass_admin/purchase', {
      mcd: login.mcd,
      token: get_token(),
      cid: login.cid,
      tcid: tcid,
      level: login.level,
      sdate: sdate,
      edate: moment(sdate).add(1, 'day').format('YYYY-MM-DD')
    });

    // 0원 데이타 빼고
    if(result.data.success===1) {
      result.data.rows = result.data.rows.filter(el=> el.amount>0);
      setRows(result.data.rows);
    }    
  }

  useEffect(() => {
    load_data();
  }, []);

  // const columns = [
  //   { field: "id", headerName: "id", hide: true },
  //   { field: "regdate", headerName: "등록", width: 140, align: "center" },
  //   {
  //     field: "name",
  //     headerName: "이름",
  //     width: 110,
  //   },
  //   {
  //     field: "gubun",
  //     headerName: "구분",
  //     width: 110,
  //     renderCell: (params) => {
  //       return params.row.gubun;
  //     },
  //   },
  //   {
  //     field: "item",
  //     headerName: "상품명",
  //     width: 190,
  //     renderCell: (params) => {
  //       return params.row.itemName;
  //     },
  //   },
  //   {
  //     field: "amount",
  //     headerName: "구매가",
  //     width: 90,
  //     align: "right",
  //     renderCell: (params) => {
  //       return params.row.amountf;
  //     },
  //   },
  //   { field: "pt_count", headerName: "수량", align: "center" },
  //   { field: "method", headerName: "결제구분", align: "center" },
  //   { field: "term", headerName: "유효기간", width: 200, align: "center" },
  //   { field: "cname", headerName: "센터명", width: 140, align: "cname" },
  // ];

  const columns = [{
    dataField: 'id',
    text: 'id',
    hidden: true
  },
  {
    dataField: 'regdate',
    text: '구매일',
    align: 'left',
    headerStyle: { width: 140, textAlign: 'left' }
  },
  {
    dataField: 'name',
    text: '이름',
    align: 'left',
    headerStyle: { width: 90, textAlign: 'left' }
  }, {
    dataField: 'gubun',
    text: '구분',
    headerStyle: { width: 90 }
  }
    , {
    dataField: 'itemName',
    text: '상품명',
    headerStyle: { width: 130, textAlign: 'left' }
  }
    , {
    dataField: 'amount',
    text: '구매가',
    headerStyle: { width: 90 },
    sort: true
  }
    , {
    dataField: 'pt_count',
    text: '쿠폰수',
    headerStyle: { width: 90 }
  }
    , {
    dataField: 'method',
    text: '결제구분',
    headerStyle: { width: 120 }
  }
    , {
    dataField: 'term',
    text: '유효기간',
    headerStyle: { width: 200 }
  }
    , {
    dataField: 'cname',
    text: '센터명',
  }
  ];

  return <Box sx={{ padding: 2, minHeight: 400 }}>
    <BootstrapTable keyField='id' data={rows} columns={columns}
      striped
      pagination={paginationFactory()}
      noDataIndication="자료가 없습니다."
    />
  </Box>
}


// ======================= //
// 즐겨찾는 센터
// ======================= //
// function FcenterSelect(props) {

//   const {p_setFcid} = props;
//   const [fcid, setFcid] = useState('');
//   const [rows, setRows] = useState([]);
//   const load_data = async () => {
//     let result = await axios.post(configState.api + "/gympass_admin/center_list");

//     // 두써킷 센터만
//     result.data = result.data.filter(el => el.cid === 'CID00000009' 
//     || el.cid === 'CT17X10111035.huwy5'
//     || el.cid === 'CT14Z01170314.HXZb9'
//     );
//     setRows(result.data);
//   }

//   useEffect(() => {
//     load_data();
//   }, []);

//   return <FormControl sx={{ width: 200}} size="small">
//     <InputLabel>즐겨찾는센터</InputLabel>
//     <Select
//       name="fcid"
//       label="즐겨찾는센터"
//       onChange={(e) => { 
//         setFcid(e.target.value);
//         p_setFcid(e.target.value);
//       }}      
//       value={fcid}
//     >
//       { rows.map((item, index) => {
//         return <MenuItem key={index} value={item.cid}>{item.center}:{item.location}</MenuItem>
//       }) }
//     </Select>
//   </FormControl>
// }

// useEffect(() => {
//   // console.log("login:", login.mcd);
//   // console.log("tcid:", tcid);
//   // console.log("sdate:", sdate);
//   // console.log("edate:", edate);
//   if (login.mcd !== "" && tcid !== "" && sdate !== "" && edate !== "") {
//     load_data();
//   }
// }, [login, tcid, sdate, edate, calendar_type]);